import "../../../../../css/CashflowModeller2/Buttons/AddButton.css"; // Import your CSS file
import { useState } from "react";

/**
 * AddButton component renders a customizable button for adding items.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} [props.buttonText] - The text to display on the button. Defaults to "Add".
 * @param {boolean} [props.isDisabled] - If true, disables the button.
 * @param {function} [props.onClick] - Callback function to execute when the button is clicked.
 *
 * @returns {JSX.Element} The rendered AddButton component.
 */
const AddButton = ({ buttonText,isDisabled, onClick }) => {
  const [clicked, setClicked] = useState(false);
  // const handleClick = () => {
  //   navigate(link); // Navigate to the provided link
  // };

  return (
    <>
    <div
      className={`addButton ${isDisabled ? "disabled" : ""} `}
      onClick={() => {
        setClicked(!clicked); // Toggle the clicked state
        // handleClick(); // Uncomment if navigation is needed
        onClick && onClick();
      }}
    >
        <div className="Input">{ buttonText || "Add"}</div>
    </div>
    
    </>
  );
};

export default AddButton;
